(window.SizeGuide = function (Behaviors) {

  "use strict";
  
  function SizeGuide(elem) {
    Behaviors.init(SizeGuide, this, arguments)

    this.container = this.$elem[0];

    //Main Tabs
    this.container.querySelectorAll('.main-tab').forEach(item => {
      item.addEventListener('click', (e)=> {
        this.container.querySelector('.main-tab--active').classList.remove('main-tab--active');
        e.currentTarget.classList.add('main-tab--active');

        let tab = e.currentTarget.dataset.tab;
        this.container.querySelector('.main-tab-content--active').classList.remove('main-tab-content--active');
        this.container.querySelector(`[data-tab-content="${tab}"]`).classList.add('main-tab-content--active');
      });
    });

    //Secondary Tabs
    this.container.querySelectorAll('.secondary-tab').forEach(item => {
      item.addEventListener('click', (e)=> {
        e.currentTarget.parentNode.querySelector('.secondary-tab--active').classList.remove('secondary-tab--active');
        e.currentTarget.classList.add('secondary-tab--active');

        let tab = e.currentTarget.dataset.helpertab;
        e.currentTarget.closest('.main-tab-content').querySelector('.secondary-tab-content--active').classList.remove('secondary-tab-content--active');
        e.currentTarget.closest('.main-tab-content').querySelector(`[data-helpertab-content="${tab}"]`).classList.add('secondary-tab-content--active');
      });
    });
   
  }

  Behaviors.inherit(SizeGuide, Behaviors.Behavior);
  SizeGuide.QUERY = '.size-guide';

  Behaviors.register_behavior(SizeGuide);
  
  return SizeGuide;

  }(window.Behaviors));